import { gsap } from "gsap";

const initNeighbourhoodMap = () => {
  const pin = document.querySelector(".js-map-pin");
  const circle = document.querySelector(".js-map-circle");
  const text = <HTMLElement | null>document.querySelector(".js-marker");

  if (!pin || !circle || !text) {
    return;
  }

  gsap.set([pin, text], {
    opacity: 0,
  });

  const hidePin = () =>
    gsap.to([pin, text], {
      opacity: 0,
      duration: 0.3,
    });

  const positionText = () => {
    const { x, y, width, height } = circle.getBoundingClientRect();

    if (!x || !y || !width || !height) {
      return;
    }

    text.style.transform = `translate(${x}px, ${y}px)`;
    text.style.width = `${width}px`;
    text.style.height = `${height}px`;
    window.requestAnimationFrame(positionText);
  };

  positionText();

  const PIN_HORIZONTAL_OFFSET = 103;
  const PIN_VERTICAL_OFFSET = 300;

  const icons = document.querySelectorAll<HTMLElement>(".js-map-icon");

  icons.forEach((icon) => {
    icon.addEventListener("mouseenter", () => {
      // Show the pin.
      document.querySelectorAll<HTMLElement>(".js-map-text").forEach((text) => {
        gsap.set(text, {
          display: text.dataset.textId === icon.id ? "block" : "none",
        });
      });

      gsap.set([pin, text], {
        opacity: 0,
      });

      gsap.to([pin, text], {
        opacity: 1,
        duration: 0.3,
      });

      gsap.from(icon.querySelector(".map__dummy"), {
        scale: 1.5,
      });

      gsap.from(icon, {
        y: -5,
        duration: 0.75,
      });

      pin.setAttribute(
        "transform",
        `translate(${Number(icon.dataset.x) - PIN_HORIZONTAL_OFFSET}, ${
          Number(icon.dataset.y) - PIN_VERTICAL_OFFSET
        })`
      );

      // Close the pin after the mouse leaves our target locations.
      const close = setInterval(() => {
        if (
          [text, pin, ...icons].some((element) => element.matches(":hover"))
        ) {
          return;
        }

        clearInterval(close);
        hidePin();

        gsap.set(icon, {
          y: 0,
        });
      }, 1200);
    });
  });
};

export default initNeighbourhoodMap();
